'use client';

import { useContext, useEffect, useState } from 'react';
import { AuthContext } from '@/app/components/Authentication';
import { checkAdmin } from '@/services/userLoginApi';

export function useAdminCheck() {
  const { isAuthenticated, userId } = useContext(AuthContext);
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!isAuthenticated) {
      setIsAdmin(false);
      setLoading(false);
      return;
    }

    let mounted = true;
    setLoading(true);

    checkAdmin()
      .then((res) => {
        if (mounted) setIsAdmin(Boolean(res.is_admin));
      })
      .catch(() => {
        if (mounted) setIsAdmin(false);
      })
      .finally(() => {
        if (mounted) setLoading(false);
      });

    return () => {
      mounted = false;
    };
  }, [isAuthenticated, userId]);

  return { isAdmin, loading };
}
